export default "__VITE_ASSET__d62a5a33__";